import NiceApiRequest from "@/apiRequests/resources/communityTalk/niceApiRequest";
import { NicePostRequest } from "@/apiRequests/models/communityTalk/nicePostRequest";

export default class NiceDomain {
	private readonly _niceApiRequest: NiceApiRequest;

	/**
	 * コンストラクタ。
	 */
	constructor() {
		this._niceApiRequest = new NiceApiRequest();
	}

	/**
	 * いいね投稿APIへのリクエスト。
	 * @param tenantId テナントID
	 * @param tagCd コミュニティトークのタグコード
	 * @param talkType どちらに対していいねを送るか
	 * @param talkId いいね対象のトークルーム・リプライID
	 * @param publishCookieId ReviCoCookieId
	 * @param tenantMemberCd テナントサイトの会員コード
	 */
	public async postNiceData(tenantId: string, tagCd: string, talkType: "TalkRoom" | "Reply", talkId: string, publishCookieId: string, tenantMemberCd?: string): Promise<string> {
		// APIリクエスト用にデータ成形
		const request: NicePostRequest = {
			tenantId: tenantId,
			tagCd: tagCd,
			talkType: talkType,
			talkId: talkId,
			publishCookieId: publishCookieId,
			tenantMemberCd: tenantMemberCd,
		};
		return await this._niceApiRequest.postNice(tenantId, request);
	}
}
